import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { GlobeSimple } from '@phosphor-icons/react';

const LanguageSwitcher = () => {
  const { lang, setLang, LANGUAGES } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const current = LANGUAGES.find(l => l.code === lang);

  return (
    <div className="relative" ref={ref} data-testid="language-switcher" data-no-translit="true">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 border border-[#E8E1D5] rounded bg-white hover:border-brand-primary/40 transition-colors text-sm"
        data-testid="language-switcher-btn"
      >
        <GlobeSimple size={16} className="text-brand-primary" />
        <span className="font-medium">{current?.flag}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white border border-[#E8E1D5] rounded shadow-lg z-50 min-w-[140px] overflow-hidden">
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              onClick={() => {
                localStorage.setItem('eventbook_lang_user_picked', '1');
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 hover:bg-brand-primary/5 transition-colors ${lang === l.code ? 'bg-brand-primary/10 font-bold text-brand-primary' : 'text-text-primary'}`}
              data-testid={`lang-option-${l.code}`}
            >
              <span className="font-bold text-xs w-6">{l.flag}</span>
              <span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
